<template>
  <div class="venture-grid">
    <VentureCard v-for="venture in ventures" :key="venture.slug" :venture="venture" />
  </div>
</template>

<script>
import VentureCard from './VentureCard.vue';

export default {
  name: 'VentureGrid',
  components: {
    VentureCard
  },
  props: {
    ventures: {
      type: Array,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.venture-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.5rem;
}

@media (max-width: 991px) {
  .venture-grid {
    grid-template-columns: 1fr;
  }
}
</style>
